import * as React from "react";
import { SharedGitCredentialForm } from "./SharedGitCredentialForm";
interface GitCredentialPageProps {
    spaceId: string;
    gitCredentialId: string;
}
export function GitCredentialPage({ spaceId, gitCredentialId }: GitCredentialPageProps) {
    return <SharedGitCredentialForm spaceId={spaceId} gitCredentialId={gitCredentialId}/>;
}
